<template>
    <div class="comment-input-wrapper">
        <div class="comment-input">
            <!-- 关闭留言框区域 -->
            <div class="close-area" @click="openQuitWarning">
            </div>
            <div class="leave-container" :class="{'leave-container-transform':callQuitWarning}">
                <div class='leave-main'>
                    <div @click="leaveFocus">
                        <textarea maxlength="100" class='leave-textarea' ref='leaveFocus' :placeholder="commentInputPlaceholder" v-model='inputContent' @blur="leaveBlur"></textarea>
                    </div>
                    <div class="leave-img" v-if="imgBase64.length>0">
                        <div class='leave-select-img' v-for="(uploadFile,index) in imgBase64" :key="index">
                            <img :src='uploadFile.FileUrl' class='upload-img source-img'  @click.stop="showImg(index,imgBase64)" >
                            <div class='close-img' @click.stop="deleteImg(index)">
                                <span class='close-span'></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="leave-footer">
                    <!-- 如果是微信端测试开发环境 -->
                    <div v-if="authType == 'WECHAT'" class="upload-input-wrapper">
                        <input ref="uploadInput" type='file' name="imgfiles" id="test" class="upload-input" multiple="multiple" accept="image/*" @change="uploadImage($event)">
                    </div>
                    <!--如果是阿波罗、mate环境-->
                    <div v-if="authType == 'TOOLKIT'" class="upload-input-wrapper" @click="chooseImg()"></div>
                    <div></div>
                    <button class='footer-btn' :class="{'footer-btn-clickable':(commentContentNoSpace.length || imgBase64.length) && submitOnOff}" @click='publish'>发布</button>
                </div>
            </div>
        </div>
        <!-- 当点击蒙层时的评论退出提醒 -->
        <quit-message v-if='callQuitWarning' :messageTitle="messageTitle"  :messageText="messageText" :queryBtn="queryBtn" @closeQuitWarning='closeQuitWarning' @eventContinue="eventContinue"></quit-message>


        <!-- 图片预览 -->
        <photo-package v-if="sourceList && sourceList.length" :list="sourceList" :options="options" selector=".source-img" @on-close="closeHandler" ref="sourcePreview">
        </photo-package>
    </div>
</template>

<script>
    import { COMMENTS} from '../api'
    import quitMessage from '@/components/quitMessage'
    import wx from 'weixin-js-sdk'
    import dsBridge from '../utils/jsbridge'
    import urlToFile from '../utils/urlToBase64'
    import PhotoPackage from 'photoswipe-package'
    export default {
        name: 'leaveQuestion',
        data() {
            return {
                toRouterPath:'',  //跳转路由，用于退出确认
                inputContent: '',//输入框内容
                imgBase64: [],//上传的图片对象数组
                callQuitWarning:false,
                messageTitle:'是否继续退出',
                messageText:'未提交内容将不会被保存,是否继续退出?',
                queryBtn:'继续退出',
                submitOnOff:true,  //评论节流

                // 图片预览组件
                sourceList:null,
                options: {
                    loop: false,
                    zoomEl: true,
                    fullscreenEl: false,
                    tapToClose: true
                },
            }
        },
        props: ['commentInfo','quitLeaveShow', 'extraInfo'],
        components: {quitMessage,PhotoPackage},
        computed: {
            NODE_ENV() {
                return process.env.NODE_ENV
            },
            authType() {
                return localStorage.AUTH_TYPE
            },
            commentContentNoSpace(){
                return this.inputContent.replace(/(^\s*)|(\s*$)/g, "")
            },
            commentInputPlaceholder(){
                return this.$store.getters.GET_InputPlaceholder
            },
        },
        mounted() {
            this.$nextTick(()=>{
                this.leaveFocus()
            })
        },
        methods: {
            leaveBlur(){
                document.body.scrollTop = 0;
            },
            leaveFocus(){
                this.$refs.leaveFocus.focus();
            },
            //调用微信sdk  app sdk 上传相册
            chooseImg(){
                switch (this.authType) {
                    case 'WECHAT':
                        console.log('WECHAT');
                        return
                        wx.chooseImage({
                            count:3,
                            sizeType:['original'],
                            success(res){
                                let localIds = res.localIds;      // 上传的图片的id,可以用于本地直接显示图片；
                                // that.getLocalImgDataFn(res.localIds[0]);   // 把本地图片转成base64码
                                // COMMENTS.FileUpload(fd).then(respsone=>{
                                //     alert("res--wx-FileUpload--");
                                //     alert(JSON.stringify(respsone));

                                //     if(respsone.Data && respsone.Data.Slug) that.imgBase64.push(respsone.Data)
                                // })
                            },
                            fail(err) {
                                that.$store.commit('SetAndCallToast',err)
                            },
                        });
                        break;
                    case 'APOLLO':
                        if(3 - this.imgBase64.length < 0) {
                            this.$store.commit('SetAndCallToast','最多只能上传3张图片哦');
                            break;
                        }
                        console.log('APOLLO');
                        dsBridge.call("ApolloApp.invokeAsyn",{
                            "methodName": "openAlbum",
                            "params": {
                                "imageCount": 3 - this.imgBase64.length
                            }
                        }, function (res) {  //异步调用
                            console.log(res);
                        })
                        break;
                    case 'TOOLKIT':
                        if(3 - this.imgBase64.length <= 0) {
                            this.$store.commit('SetAndCallToast','最多只能上传3张图片哦');
                            break;
                        }
                        const that = this;
                        dsBridge.call("CommonMediaBridge.openMedia", {
                            "getType":"album",
                            "parameters": {
                                "max":3 - this.imgBase64.length 
                            }
                        },function(data){
                            let imgUrlArr = data.data
                            imgUrlArr.forEach((e,i)=>{
                                urlToFile(e.url,i,(base64)=>{
                                    if(base64 == '跨域') {
                                        that.$store.commit('SetAndCallToast','图片转换失败')
                                    }else{
                                        let fd = {
                                            image_base64: base64
                                        }
                                        COMMENTS.FileUploadByBase64(fd).then(res=>{
                                            if(res.Data && res.Data.Slug) that.imgBase64.push(res.Data)
                                        })
                                    }
                                })
                            })
                        });
                        break;
                }
            },
            getLocalImgDataFn(localId){
                let _this = this;
                wx.getLocalImgData({
                    localId: localId, // 图片的localID
                    success: function (res) {
                        let basePic64 = res.localData;    // 微信返回的base64码；
                        alert("res--wx-getLocalImgDataFn--");
                        alert(JSON.stringify(res));
                        // if(basePic64.indexOf('base64')>0){
                        // let file = _this.iosDataURLtoFile(basePic64,'jpg');
                        // _this.saveImg(file,basePic64)
                        // }else{
                        // let file = _this.dataURLtoFile(basePic64,'jpg');
                        // _this.saveImg(file,localId)
                        // }
                    }
                });
            },
            // 输入框打开文件夹上传图片
            uploadImage(event) {
                //获取图片
                let _event = window.event || event;
                let files = _event.target.files;
                let filesArray = [];
                //遍历所有文件
                for (var i = 0; i < files.length; i++) {
                    files.item(i).size > 10485760 ? this.$store.commit('SetAndCallToast','请上传小于10M的图片') : filesArray.push(files.item(i))
                }
                // let filesArray = Object.values(files);   //PC端企微用Object.value拿到的fileList有问题 透他来来的
                // 控制上传数量
                this.$refs.uploadInput.value=null;
                if (filesArray.length > 3 || (this.imgBase64.length + filesArray.length) > 3) {
                    this.$store.commit('SetAndCallToast','最多只能上传3张图片哦')
                    return;
                }
                this.sendImageDataToBackEnd(filesArray)
            },
            // 上传图片到后端
            sendImageDataToBackEnd(filesArray){
                filesArray.map((v, k) => {
                    //创建读取文件的对象
                    var reader = new FileReader();
                    //为文件读取成功设置事件
                    reader.onload=function(e) {
                        let imgFile = e.target.result;
                    };

                    //正式读取文件
                    reader.readAsDataURL(v);
                    //判断上传类型
                    if (!v || v.type.split('/')[0] !== "image") {
                        this.$store.commit('SetAndCallToast','只能上传图片哦')
                        return;
                    }

                    let fd = new FormData()
                    fd.append('file' + k, v)
                    COMMENTS.FileUpload(fd).then(res=>{
                        if(res.Data && res.Data.Slug && res.Code == 200) this.imgBase64.push(res.Data)
                        if(res.Code != 200) this.$store.commit('SetAndCallToast', res.Msg)
                    })
                })
            },
            //删除上传的图片
            deleteImg(index) {
                this.imgBase64.splice(index, 1);
            },
            //留言提交
            publish() {
                if(!this.commentContentNoSpace.length && !this.imgBase64.length) return;
                if (this.commentContentNoSpace.length > 100) {
                    this.$store.commit('SetAndCallToast','评论字数不能超过100字哦')
                } else {
                    if(!this.submitOnOff) return;
                    this.submitOnOff = false
                    let AttachList = [];
                    let imgUrlList = [];
                    this.imgBase64.forEach(e=>{
                        AttachList.push(e.Slug)
                        imgUrlList.push(e.FileUrl)
                    })

                    let commentId = null
                    if (this.extraInfo) {  // 知识点详情页面调用
                        commentId = this.extraInfo.Id
                    } else {  // replyList调用
                        if (this.commentInfo) {
                            commentId = this.commentInfo.CommentId || this.commentInfo.Id
                        } else commentId = ''
                    }

                    COMMENTS.AddComment({
                        "KBInfoId": this.$route.params.uuid.split('&')[0],
                        "Comment": this.commentContentNoSpace,
                        // CommentId是ReplyList中的字段 Id是Main中的字段
                        "CommentId": commentId,
                        // "CommentId": this.commentInfo ? (this.commentInfo.CommentId || this.commentInfo.Id) : '',
                        // "CommentId": this.commentInfo ? (this.commentInfo.Id || this.commentInfo.CommentId) : '',
                        "AttachList": AttachList
                    }).then((res) => {
                        if (res.Code == 200) {
                            //判断是否是发布还是回复
                            this.$store.commit('SetAndCallToast', this.commentInfo ? '回复成功': '发布成功')
                            setTimeout(()=>{
                                let answerSomeInfo = {
                                    // 在这里新建单条评论详情
                                    Name:res.Data.Name,
                                    ADAccount:res.Data.ADAccount,
                                    AttachList: imgUrlList,
                                    CommentId: res.Data.Id,
                                    Comment:this.commentContentNoSpace,
                                    IsAdmin: true,
                                    IsDel: false,
                                    Identity:res.Data.Identity,
                                    HeadImage:res.Data.HeadImage,
                                    MainCommentId: res.Data.MainCommentId,
                                    ReplyMessage: this.commentContentNoSpace,
                                    CreateTime: res.Data.CreateTime
                                }
                                this.submitOnOff = true;
                                this.$emit('successPush',answerSomeInfo);
                            },1500)
                        } else {
                            this.$store.commit('SetAndCallToast','发布失败')
                            this.submitOnOff = true;
                        }
                    }).catch((error) => {
                        this.$store.commit('SetAndCallToast','发布失败'+ error)
                        this.submitOnOff = true;
                    })

                }
            },
            //试图退出输入框时，打开警告框
            openQuitWarning() {
                if(!this.commentContentNoSpace.length && !this.imgBase64.length) {
                    this.$store.commit('SET_CallCommentInput',false)
                }else{
                    this.callQuitWarning=true;
                }
            },
            //关闭close弹框
            closeQuitWarning(){
                this.callQuitWarning=false;
            },
            //点击继续按钮
            eventContinue(){
                this.$store.commit('SET_InputContent',false)
                this.$store.commit('SET_CallCommentInput',false)
                this.callQuitWarning=false
            },
            showImg(index,sourceList) {
                // 图片预览
                let imgList = sourceList.map((e)=>{
                    return {
                        // transfer key named `FileUrl` to `src`
                        src: e.FileUrl,
                        FileName: e.Slug,
                        FileType: 'jpg'
                    }
                })
                this.sourceList = imgList
                this.$nextTick(()=>{

                    this.$refs.sourcePreview.show(index)
                })
            },
            closeHandler(){
                this.sourceList = [];
            }
        },
        watch: {
            commentContentNoSpace(value){
                this.$store.commit('SET_InputContent', value)
            },
            quitLeaveShow(newValue,oldValue){
                this.$refs.leaveFocus.blur();
            }

        },
    }
</script>

<style lang='scss' type="text/scss" scoped>
    .comment-input {
        .close-area{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 105;
            background: rgba(0, 0, 0, .3);
        }
        .leave-container {
            width: 100%;
            background: #fff;
            position: fixed;
            left: 0;
            bottom: 0;
            z-index: 1102;
            opacity:1;
            .leave-main {
                box-sizing: border-box;
                width: j(650);
                background-color: #F7F7F8;
                margin: j(15) j(50) j(28);
                border-radius: j(4);
                padding: j(15) 0;
                .leave-textarea {
                    display: block;
                    width: j(650);
                    min-height:j(232);
                    background-color: transparent;
                    line-height: j(40);
                    font-size:j(28);
                    color:#363C54;
                    padding: 0 j(30);
                    box-sizing: border-box;
                    caret-color: #00BEBE;
                    resize: none;
                    transform: translateY(0);
                }
                .leave-img {
                    width: j(650);
                    height: j(120);
                    margin: j(30) 0 0;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    box-sizing: border-box;
                    padding: 0 j(30);

                    .leave-select-img {
                        width: j(120);
                        height: j(120);
                        margin-right: j(50);
                        position: relative;
                        .upload-img {
                            width: 100%;
                            height: 100%;
                            display: block;
                            position: absolute;
                        }

                        .close-img {
                            width: j(40);
                            height: j(40);
                            border-radius: j(20);
                            background: #696D7F;
                            position: absolute;
                            top: j(5);
                            right: j(4);
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .close-span {
                                width: j(3);
                                height: j(24);
                                background: #fff;
                                position: relative;
                                transform: rotate(45deg);
                                display: inline-block;
                                &:after {
                                    content: "";
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: j(3);
                                    height: j(24);
                                    background: #fff;
                                    transform: rotate(270deg);
                                }
                            }

                        }
                    }
                }
            }
            .leave-footer {
                width: j(650);
                height: j(60);
                margin: 0 j(50) j(25);
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;

                .upload-input-wrapper {
                    width: j(40);
                    height: j(40);
                    background:url("/static/images/icon/photo.png") no-repeat;
                    background-size: contain;
                    position: relative;
                }
                .upload-input {
                    width: j(40);
                    height: j(40);
                    opacity: 0;
                    position: absolute;
                    top: 0;
                    left: 0;
                }


                .footer-btn {
                    width: j(130);
                    height: j(60);
                    background: #CDCED4;
                    border: none;
                    border-radius: j(30);
                    font-size: j(24);
                    font-weight: 700;
                    color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    outline:none!important;
                }

                .footer-btn-clickable {
                    background: #00BCBC!important;
                }
            }
        }
        .leave-container-transform{
            transform:translateY(100px);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/leaveQuestion.vue